import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, IconButton, Typography, Avatar, Menu, MenuItem, Box } from "@mui/material";
import { Menu as MenuIcon, AccountCircle, PowerSettingsNew, Settings, Inbox, Help } from "@mui/icons-material";
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../store/auth/authSlice';
import { useNavigate, useLocation } from "react-router-dom";

// profile menu items
const profileMenuItems = [
  { label: "Mi Perfil", icon: AccountCircle, path: "/perfil" },
  { label: "Plan", icon: Inbox, path: "/plan" },
  { label: "Cerrar Sesión", icon: PowerSettingsNew },
  { label: "Ayuda", icon: Help, path: "/ayuda" },
];

// ProfileMenu component
function ProfileMenu({ handleLogout, whoami }) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = (index) => {
    setAnchorEl(null);
    // Obtener el elemento del menú seleccionado
    const selectedItem = profileMenuItems[index];

    // Verificar que el elemento seleccionado no sea undefined
    if (selectedItem) {
      // Manejar la navegación basada en el path o acción específica
      if (selectedItem.path) {
        // Set flag in localStorage if going to plan page
        if (selectedItem.path === "/plan") {
          localStorage.setItem("comingFromMenu", "true");
        }
        navigate(selectedItem.path);
      } else if (index === profileMenuItems.length - 2) {
        handleLogout();
      }
    }
  };

  return (
    <div>
      <IconButton onClick={handleMenuOpen} size="large" edge="end" color="inherit">
        <Box sx={{ display: { xs: 'none', md: 'block' }, ml: 1 }}>
          <Typography variant="body1">
            Bienvenido, {whoami?.name} {whoami?.lastme}
          </Typography>
        </Box>
        <Avatar className="ml-4" alt={`${whoami?.name} ${whoami?.lastname}`} src={whoami?.avatar || "https://cdn.pixabay.com/photo/2021/11/24/05/19/user-6820232_1280.png"} />
      </IconButton>
      <Menu
        className="mt-12 ml-2"
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={() => handleMenuClose(null)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {profileMenuItems.map(({ label, icon: IconComponent }, index) => (
          <MenuItem
            key={label}
            onClick={() => handleMenuClose(index)}
          >
            <IconComponent style={{ marginRight: 10 }} />
            {label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

// NavBar component
export function NavBar() {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();


  const { isAuthenticated, whoami } = useSelector((state) => state.auth);


  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  const toggleIsNavOpen = () => setIsNavOpen((prev) => !prev);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 960) {
        setIsNavOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    isAuthenticated && (
      <AppBar position="static" sx={{ backgroundColor: "white", color: "black" }}>
        <Toolbar>
          <Typography
            variant="h6"
            component="a"
            onClick={(e) => {
              e.preventDefault();
              localStorage.removeItem("comingFromMenu");
              navigate("/menu");
            }}
            sx={{
              flexGrow: 1,
              cursor: "pointer"
            }}
          >
            {location.pathname === "/menu" ? "Global Advanced Data" : "Regresar al menú"}
          </Typography>

          {/* Menu Button for Mobile View */}
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={toggleIsNavOpen}
            sx={{ display: { xs: "block", md: "none" } }}
          >
          </IconButton>

          {/* Profile Menu */}
          <ProfileMenu handleLogout={handleLogout} whoami={whoami} />
        </Toolbar>
      </AppBar>
    )
  );
}
